/**
 * Rounding up donation on the Cart
 */

if (!customElements.get('donation-module')) {

  class DonationModule extends HTMLElement {
    constructor() {
      super();

      // Variables
      this.roundUp = this.dataset.donationType == "round-up-cart" ? true : false;
      this.roundUpModulo = 500;
      this.freeAmount = parseInt(this.dataset.freeAmount);
      this.roundUpIfZero = parseInt(this.dataset.roundUpIfZero);
      this.productId = parseInt(this.dataset.productId);
      this.variantId = parseInt(this.dataset.variantId);
      this.donation250Products = this.dataset.donationTwoFiftyProducts ? this.dataset.donationTwoFiftyProducts.split(', ').map((item) => parseInt(item)) : [];
      this.isUpdating = false;

      // Selectors
      this.cartItems = document.querySelector('cart-items');

      // Change round up and free amount
      this.addEventListener('change', (e) => {
        if (e.target.hasAttribute('data-round-up-price')) {
          this.onChangeRoundUp(e.target.checked);
        }
        if (e.target.hasAttribute('data-free-amount-input')) {
          this.onChangeFreeAmount();
        }
      });

      // Key up free amount
      this.addEventListener('keyup', (e) => {
        if (e.target.hasAttribute('data-free-amount-input')) {
          this.onKeyUpFreeAmount();
        }
      });

      // Debounce save the donation function
      this.debouncedUpdateDonation = debounce(() => {
        this.updateDonation();
      }, 500);

      // Submit donation
      document.querySelector('[data-submit-donation]')?.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('[data-submit-cart-button]').dispatchEvent(new MouseEvent('click', {
          bubbles: false,
          cancelable: false,
        }));
      });

      // Submit without donation
      document.querySelector('[data-submit-without-donation]')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.cartItems.skipDonation = true;
        document.querySelector('[data-submit-cart-button]').dispatchEvent(new MouseEvent('click', {
          bubbles: false,
          cancelable: false,
        }));
      });

    }

    // Sections to render after cart/donation update
    getSectionsToRender() {
      const sections = [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        }
      ]
      if (document.getElementById('donation-module')) {
        sections.push({
          id: 'donation-module',
          section: document.getElementById('donation-module').dataset.id,
          selector:'[data-donation-module-content]'
        });
      }
      if (document.getElementById('donation-pop-up')) {
        sections.push({
          id: 'donation-pop-up',
          section: document.getElementById('donation-pop-up').dataset.id,
          selector:'[data-pop-up-donation-module-content]'
        });
      }
      return sections;
    }

    // Get section Inner html
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    // When select/deselect round up checkbox
    onChangeRoundUp(checked) {
      document.querySelectorAll('donation-module').forEach((module) => {
        module.roundUp = checked;
      });
      if (this.roundUp) {
        document.querySelectorAll('donation-module').forEach((module) => {
          module.freeAmount = 0;
        });
        document.querySelectorAll('[data-free-amount-input]').forEach((input) => {
          input.value = '';
        });
      }

      // Update updating state
      document.querySelectorAll('donation-module').forEach((module) => {
        module.isUpdating = true;
      });

      // Update cart
      this.debouncedUpdateDonation();
    }

    // Save free amount value
    onKeyUpFreeAmount() {

      // Set state
      document.querySelectorAll('donation-module').forEach((module) => {
        module.roundUp = false;
      });
      document.querySelectorAll('[data-free-amount-input]').forEach((input) => {
        input.checked = false;
      });

      // Get value and parse it.
      let value = Math.round(Number(
        this.querySelector('[data-free-amount-input]').value.replace(/,/g, ".")
      ).toFixed(2) * 100);

      // Get min
      let min = Math.round(Number(
        this.querySelector('[data-free-amount-input]').min.replace(/,/g, ".")
      ).toFixed(2) * 100);

      if (value < min) {
        value = min;
      }

      // Update value and updating state
      document.querySelectorAll('donation-module').forEach((module) => {
        module.isUpdating = true;
        module.freeAmount = parseInt(value);
      });
    }

    // When free amount changes
    onChangeFreeAmount() {

      // Update value
      document.querySelectorAll('[data-free-amount-input]').forEach((input) => {
        if (this.freeAmount <= 0) {
          input.value = '';
        } else {
          input.value = Number(this.freeAmount / 100).toFixed(2);
        }
      });

      // Update updating state
      document.querySelectorAll('donation-module').forEach((module) => {
        module.isUpdating = true;
      });

      // Update cart
      this.debouncedUpdateDonation();
    }

    // Update in cart
    updateDonation() {

      return new Promise((resolve ,reject)=>{
        try {

          (async () => {
            // add loader
            this.cartItems.enableLoading();
            if (document.querySelector('[data-submit-donation]')) {
              document.querySelector('[data-submit-donation]').classList.add('loading');
              document.querySelector('[data-submit-donation]').setAttribute('disabled', 'disabled');
            }

            // Get all cart information
            let cart = await fetch(`${routes.cart_url}`, {...fetchConfig()});
            cart = await cart.text();
            cart = parseJson(cart);

            // Capture Variables
            let removeItems = {};
            let donationItems = cart.items.filter((item) => item.product_id == this.productId);
            let donationType = 'round-up-cart';
            let total = {
              cart : cart.items_subtotal_price,
              donation : 0,
              full: null,
            }
            let sections;

            // Set round up module to 250 if only one 250 product is in cart
            this.roundUpModulo = 500;
            if (this.roundUp && (cart.items.length - donationItems.length) == 1) {
              let donation250Product = cart.items.filter((item) => {
                return this.donation250Products.includes(parseInt(item.product_id)) && item.quantity == 1
              });
              if (donation250Product.length == 1) {
                this.roundUpModulo = 250;
              }
            }

            // Add current donation product to remove array
            if (donationItems.length != 0) {
              donationItems.forEach((item) => {
                removeItems[`${item.key}`] = 0;
                total.cart -= item.final_price;
              });
            }

            // Calculate donation amount (if round up)
            if (this.roundUp && donationType) {
              donationType = 'round-up-cart';
              let roundUp = Math.round( (this.roundUpModulo - ( total.cart % this.roundUpModulo) ) * 100 ) / 100;
              if (roundUp >= this.roundUpModulo || roundUp <= 0) {
                roundUp = this.roundUpIfZero;
              }
              total.donation += roundUp;
            }

            // Calculate donation amount (if free amount)
            else if (this.freeAmount > 0 && donationType) {
              donationType = 'free-amount-cart';
              total.donation += this.freeAmount;
            }

            // Get total
            total.full = total.cart + total.donation;

            // Remove old donation products
            if (Object.keys(removeItems)) {
              const body = JSON.stringify({
                updates: removeItems,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });

              let removeCart = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
              removeCart = await removeCart.text();
              removeCart = parseJson(removeCart);
              sections = removeCart.sections;
            }

            // Add donation product to cart
            if (total.donation > 0) {
              const body = JSON.stringify({
                items: [
                  {
                    id: parseFloat(this.variantId),
                    quantity: 1,
                    properties: {
                      _donation_price: total.donation,
                      _donation_type: donationType,
                    }
                  }
                ],
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });

              let addCart = await fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }});
              addCart = await addCart.text();
              addCart =  parseJson(addCart);
              sections = addCart.sections;
            }

            // Update HTML
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              if (!elementToReplace) {
                return;
              }
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(sections[section.section], section.selector);
            }));


            // Set opt-in state
            if (document.querySelector('[data-round-up-price]')) {
              if (total.donation == 0) {
                document.querySelector('[data-round-up-price]').checked = false;
              } else if (donationType == 'round-up-cart') {
                document.querySelector('[data-round-up-price]').checked = true;
              }
            }

            // Set policy state
            if (document.querySelector('[name="attributes[accept_policy]"]')) {
              document.querySelector('[name="attributes[accept_policy]"]').checked = this.cartItems.acceptPolicy;
            }

            // Enable/disable submit button
            if (document.querySelector('[data-submit-donation]')) {
              document.querySelector('[data-submit-donation]').classList.remove('loading');
              if (total.donation > 0) {
                document.querySelector('[data-submit-donation]').removeAttribute('disabled');
              }
            }

            // remove loader
            this.cartItems.disableLoading();
            this.cartItems.submitFormButtonHandler();

            // Donation is done updating
            document.querySelectorAll('donation-module').forEach((module) => {
              module.isUpdating = false;
            });

            // resolve
            resolve();

          })();

        } catch (error) {
          reject(error);
        }
      });
    }

  }

  window.DonationModule = DonationModule;
  customElements.define('donation-module', DonationModule);
}
